import React from 'react';
import { PiBasketball } from 'react-icons/pi';
import Link from 'next/link';
import { 
    Box, 
    Type,
} from '@saladbob/sassafras'

type Props = {
    tournament: {
        slug: string,
        title: string,
    },
    txtColor?: string,
    font?: string,
}

const fonts = {
    labels: {
        phone: 'small',
        laptop: 'p',
    },
};

const TournamentTag: React.FC<Props> = ({ tournament, txtColor, font }) => {
    return (<Link href={`/tournaments/${tournament.slug}`}>
        <Box display="inline-flex" align="center" txtColor={ txtColor || 'rgba(0, 0, 0, 0.5)'} me="md">
            <PiBasketball size="24px" />
            <Type font={font || fonts.labels} ms="xs" uppercase>
                {tournament.title}
            </Type>
        </Box>
    </Link>
)}

export default TournamentTag;